import { useMemo } from 'react';

// Our Utils
import { dataIsValid } from 'shared/utils';

function useDisableOutstandingBalanceBasedOnSource(data) {
	const shouldDisableOutstandingBalance = useMemo(() => {
		if (!dataIsValid(data) || !data?.dataSource) return false;
		return data.dataSource !== 'Manual';
	}, [data]);

	// checks negative cases first
	return shouldDisableOutstandingBalance;
}

export default useDisableOutstandingBalanceBasedOnSource;
